import { render, staticRenderFns } from "./CustomersAttended.vue?vue&type=template&id=6415b800&scoped=true"
import script from "./CustomersAttended.vue?vue&type=script&lang=js"
export * from "./CustomersAttended.vue?vue&type=script&lang=js"
import style0 from "./CustomersAttended.vue?vue&type=style&index=0&id=6415b800&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6415b800",
  null
  
)

export default component.exports